import { useRef, useEffect } from "react"
import { useUtils } from '../utils/utils';
import RideInfoLine from "./RideInfoLine";

//Shows daily ride summary info and tour dates selection
const DailyHeader = ({rideIds, selectedRideId, selectedRide, onSelectRide}) => {
  const scrollContainerRef = useRef(null);
  const { rideIdToDate } = useUtils();
  // Scroll to the selected date when it changes
  useEffect(() => {
    if (selectedRideId && scrollContainerRef.current) {
      const selectedPill = document.getElementById(`date-pill-${selectedRideId}`);
      if (selectedPill) {
        // Scroll the selected pill into view
        selectedPill.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [selectedRideId]);
  
  return (
    <div className="mb-0">
      <div className="d-flex align-items-center mb-2">
        {selectedRide && <RideInfoLine rideInfo={selectedRide} />}
      </div>
      
      <div 
        ref={scrollContainerRef}
        className="d-flex overflow-auto pb-2" 
        style={{ 
          position: 'relative',
          minHeight: '60px' 
        }}
      >
        
        {rideIds.map((rideId, index) => {
          const isSelected = selectedRideId && selectedRideId === rideId;
          const rideDate = rideIdToDate(rideId);
          return (
            <div 
              key={rideId}
              id={`date-pill-${rideId}`}
              className="d-flex flex-column align-items-center position-relative mx-2"
              style={{ zIndex: 2, minWidth: '100px' }}
            >
              <div 
                className={`rounded-pill px-3 py-1 mb-1 ${isSelected ? 'bg-primary text-white' : 'bg-light'}`}
                style={{ 
                  cursor: 'pointer',
                  border: isSelected ? '2px solid #0d6efd' : '1px solid #dee2e6',
                  transition: 'all 0.2s'
                }}
                onClick={() => onSelectRide(rideId)}
              >
                {rideDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
              </div>
              
              {/* Year label (show only for first date of the year or first date overall) */}
              {(index === 0 || 
                rideIds[index].substring(5, 9) !== rideIds[index - 1].substring(5, 9)) && (
                <div className="text-muted mt-1" style={{ fontSize: '0.8rem' }}>
                  {rideDate.getFullYear()}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DailyHeader